// src/contexts/AuthContext.js
import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

export const AuthContext = createContext({} as any);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [authTokens, setAuthTokens] = useState(() =>
    localStorage.getItem("tokens")
      ? JSON.parse(localStorage.getItem("tokens") as string)
      : null
  );
  const [user, setUser] = useState(() =>
    localStorage.getItem("tokens")
      ? jwtDecode(JSON.parse(localStorage.getItem("tokens") as string).access_token)
      : null
  );
  const [isKeyAuthAttempted, setIsKeyAuthAttempted] = useState(false);

  const loginUser = (tokens: any) => {
    setAuthTokens(tokens);
    setUser(jwtDecode(tokens.access_token));
    localStorage.setItem("tokens", JSON.stringify(tokens));
  };

  const logoutUser = () => {
    setAuthTokens(null);
    setUser(null);
    localStorage.removeItem("tokens");
  };

  // Check if a key is in the URL. If so, perform key authentication automatically.
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const key = urlParams.get("key");
    if (key && !authTokens && !isKeyAuthAttempted) {
      setIsKeyAuthAttempted(true);
      const currentHostname = window.location.hostname;
      const BASE_URL =
        process.env.REACT_APP_API_BASE_URL || `http://${currentHostname}:5000`;
      axios
        .post(`${BASE_URL}/auth/key_login`, { key })
        .then((response) => {
          loginUser(response.data);
        })
        .catch((err) => {
          console.error("Key authentication failed:", err);
        });
    }
  }, [authTokens, isKeyAuthAttempted]);

  useEffect(() => {
    if (authTokens) {
      setUser(jwtDecode(authTokens.access_token));
    }
  }, [authTokens]);

  return (
    <AuthContext.Provider value={{ user, authTokens, loginUser, logoutUser }}>
      {children}
    </AuthContext.Provider>
  );
};